module.exports = __webpack_public_path__ + "static/media/linkedin.c733b26a.svg";